/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCustomContactForm = {
  init: function ($section) {
    

  // Selectors
  const $contactForm = $('.contact-form__form');

  // Contact form checkbox validation
  if ($('[data-is-required]').length){
    var $checkboxGroup = $('.contact-form__list .checkbox');
    $checkboxGroup.prop('required', true);

    $('.contact-form__list .checkbox').on('change', function(){
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(":checked")) {
        $checkboxGroup.prop('required', false);
      }
    })
  }

  var depValue = {};    
  $('.custom-contact-form__block[data-dependencylabel]').each((index, item) => {
    depValue[$(item).data('dependencylabel')] = {'depend': $(item).data('label'), 'dependvalue':  $(item).data('dependency-value')};
  });
    
  $('[data-input]').on('change', function (e) {
    var parent =  $(e.target).parents('[data-label]');
    var label = parent.data('label');    
    var depend = depValue[label];
    var currentValue = $(e.target).val();
    if (currentValue == depend.dependvalue ){
      $section.find(`[data-label="${depend.depend}"]`).removeClass('is-hidden');
    }else {
      $section.find(`[data-label="${depend.depend}"]`).addClass('is-hidden');      
    }    
  });

  $contactForm.on('submit', function(e) {

    const $form = $(this);
    const $formBlocks = $('.contact-form__blocks [data-checkbox-required]', $form);
    const $errorMessage = Shopify.translation.contact_form_checkbox_error;
    const $errorMessageContainer = $('.form__error', $form);

    let completeForm = true;

    for (let i = 0; i < $formBlocks.length; i++ ) {
      const $checkbox = $('input[type=checkbox]:checked', $formBlocks[i]);
      if ($checkbox.length) {
        completeForm = true;
      } else {
        $errorMessageContainer.html($errorMessage);
        completeForm = false;
      }
    }

    if (completeForm) {
      return;
    } else {
      event.preventDefault();
    }
  });
  },
  unload: function () {
    const $contactForm = $('.contact-form__form');
    const $submitButton = $contactForm.find(':submit');

    $submitButton.off();

  }
}

/******/ })()
;